<template>
  <div class="middle-container bg-f5f5f5 h-48 flex items-center pl-5 pr-8 box-sizing">
    <!-- 左侧描述区域 -->
    <div class="left-desc flex-shrink-0">
      <div class="flex items-center gap-4">
        <img src="@/assets/main_label.png" alt="logo" class="w-28 h-28">
        <span class="text-16 color-label">订单中枢</span>
      </div>
      <span class="left-desc-line px-6">|</span>
      <span class="text-12 color-label">智能协同，让货运管理更简单</span>
    </div>    
    <!-- 中间Tab区域 -->
    <div class="middle-tabs flex-1 pl-12 pt-6 min-w-0">
      <el-tabs
        v-model="currentActive"
        type="card"
        @tab-click="handleTabClick"
        @tab-remove="handleTabRemove"
        class="scrollable-tabs"
      >
        <el-tab-pane
          v-for="tab in openedTabs"
          :key="tab.name"
          :label="tab.title"
          :name="tab.name"
          :closable="openedTabs.length > 1"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    
    <!-- 右侧工具区域 -->
    <div class="right-tools flex items-center gap-28 flex-shrink-0 pt-6">      
      <div @click="handlePrevTab">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div @click="handleNextTab">
        <i class="el-icon-arrow-right"></i>
      </div>
      <div @click="handleRefresh">
        <i class="el-icon-refresh-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTabs',
  props: {
    activeTab: {
      type: String,
      default: ''
    },
    openedTabs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 通过计算属性代理 prop，避免在子组件内直接修改 prop
    currentActive: {
      get() {
        return this.activeTab
      },
      set(val) {
        this.$emit('change-active', val)
      }
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit('tab-click', tab)
    },
    handleTabRemove(tabName) {
      this.$emit('tab-remove', tabName)
    },
    handleRefresh() {
      this.$emit('refresh')
    },
    handlePrevTab() {
      this.$emit('prev-tab')
    },
    handleNextTab() {
      this.$emit('next-tab')
    }
  },
  mounted() {
    this.disableAnimations()
  },
  methods: {
    disableAnimations() {
      // 通过JavaScript强制禁用所有动画
      this.$nextTick(() => {
        const tabsContainer = this.$el.querySelector('.scrollable-tabs')
        if (tabsContainer) {
          const style = document.createElement('style')
          style.textContent = `
            .scrollable-tabs * {
              transition: none !important;
              animation: none !important;
              transform: none !important;
            }
          `
          document.head.appendChild(style)
        }
      })
    },
    handleTabClick(tab) {
      this.$emit('tab-click', tab)
    },
    handleTabRemove(tabName) {
      this.$emit('tab-remove', tabName)
    },
    handleRefresh() {
      this.$emit('refresh')
    },
    handlePrevTab() {
      this.$emit('prev-tab')
    },
    handleNextTab() {
      this.$emit('next-tab')
    }
  }
}
</script>

<style scoped>
.left-desc {
  flex: 0 0 274px;
  display: flex;
  align-items: center;
}
.left-desc-line{
  color: rgba(0, 0, 0, 0.08);
}
.left-desc img{
  object-fit: cover;
}
.desc-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.desc-content {
  font-size: 12px;
  color: #666;
}

.scrollable-tabs {
  height: 100%;
}

.scrollable-tabs >>> .el-tabs__header {
  margin: 0;
  border-bottom: none;
  background: #f5f5f5;
  padding: 0;
}

.scrollable-tabs >>> .el-tabs__nav {
  background: #f5f5f5;
  border: none !important;
}

.scrollable-tabs >>> .el-tabs__item {
  padding: 0px 20px;
  color: rgba(48, 49, 51, 1);
  border-radius: 3px 3px 0 0;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  border: none !important;
  background: transparent !important;
  transition: none !important;
  animation: none !important;
  transform: none !important;
}

.scrollable-tabs >>> .el-tabs__item:hover {  
  color: rgba(48, 49, 51, 1);
  padding: 0px 20px;
  transition: none !important;
  animation: none !important;
  transform: none !important;
}

.scrollable-tabs >>> .el-tabs__item.is-active {
  background: white !important;
  color: rgba(48, 49, 51, 1) !important;
  padding: 0px 20px !important;
  font-weight: 500 !important;
  border-bottom: 2px solid #409EFF !important;
}

.scrollable-tabs >>> .el-tabs__item .el-icon-close {
  margin-left: 8px;
  font-size: 12px;
  color: #999;
}

.scrollable-tabs >>> .el-tabs__item .el-icon-close:hover {
  color: rgba(48, 49, 51, 1);
  background: white;
}
.scrollable-tabs >>> .el-tabs__nav-wrap {
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;
}

/* 确保标签页容器不会挤压右侧工具区域 */
.middle-tabs {
  min-width: 0;
  overflow: hidden;
}

/* 标签页导航区域样式 */
.scrollable-tabs >>> .el-tabs__nav {
  min-width: max-content;
}

/* 隐藏 Element UI tabs 自带的左右滚动按钮 */
.scrollable-tabs >>> .el-tabs__nav-prev,
.scrollable-tabs >>> .el-tabs__nav-next {
  display: none !important;
}


.scrollable-tabs >>> .el-tabs__content {
  display: none;
}
.right-tools i{
  cursor: pointer;
  font-size: 14px;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
}

/* 完全禁用所有动画和过渡效果 */
.scrollable-tabs >>> * {
  transition: none !important;
  animation: none !important;
  transform: none !important;
  will-change: auto !important;
}

/* 禁用Element UI内置的动画 */
.scrollable-tabs >>> .el-tabs__nav-wrap {
  transition: none !important;
  animation: none !important;
}

.scrollable-tabs >>> .el-tabs__nav {
  transition: none !important;
  animation: none !important;
}

.scrollable-tabs >>> .el-tabs__item {
  transition: none !important;
  animation: none !important;
  transform: none !important;
}

.scrollable-tabs >>> .el-tabs__item.is-active {
  background: white !important;
  transition: none !important;
  animation: none !important;
  transform: none !important;
}

/* 禁用鼠标悬停时的任何动画 */
.scrollable-tabs >>> .el-tabs__item:hover {
  transition: none !important;
  animation: none !important;
  transform: none !important;
}
</style>
